import { useCallback, useMemo, useState } from 'react'
import { useDataProvider, useGetList, useLocaleState } from 'react-admin'

export const ANNOUNCEMENTS_RESOURCE = 'announcements'

const LIST_PARAMS = { pagination: { page: 1, perPage: 20 }, sort: { field: 'published_at', order: 'DESC' } }

export const isInternalUrl = (url) => url.startsWith('/')

export const useAnnouncements = () => {
  const dataProvider = useDataProvider()
  const { data = [], isSuccess, refetch } = useGetList(ANNOUNCEMENTS_RESOURCE, LIST_PARAMS)
  const [seenIds, setSeenIds] = useState(() => new Set())

  const announcements = useMemo(
    () =>
      data.map((announcement) =>
        seenIds.has(announcement.id) ? { ...announcement, unread: false, opens_dialog: false } : announcement,
      ),
    [data, seenIds],
  )

  const markSeen = useCallback(
    (ids) => {
      if (ids.length === 0) {
        return Promise.resolve()
      }
      setSeenIds((current) => new Set([...current, ...ids]))
      return dataProvider.markAnnouncementsSeen(ids).then(() => refetch())
    },
    [dataProvider, refetch],
  )

  return {
    announcements,
    isLoaded: isSuccess,
    unreadCount: announcements.filter((announcement) => announcement.unread).length,
    markSeen,
  }
}

export const useLocalizedText = () => {
  const [locale] = useLocaleState()
  return useCallback((i18nText) => i18nText?.[locale] ?? i18nText?.en, [locale])
}
